export default {"src":"/_next/static/media/arrow.7e09fe08.svg","height":16,"width":21,"blurWidth":0,"blurHeight":0};